import { Box, Button, Dialog } from '@mui/material'
import { Close } from '@mui/icons-material'
import { NorthStarSectionInstance, NorthStarSectionTemplate } from '../../services/api'
import NorthStarDocument, { useNorthStarPageStyles } from './NorthStarDocument'

interface NorthStarPreviewDialogProps {
  open: boolean
  onClose: () => void
  sections: NorthStarSectionInstance[]
  templates: Record<string, NorthStarSectionTemplate>
  clientName: string
  currentRole: string
  /** Only set once the North Star has been published, as on the live page. */
  publishedAt?: string
  disclaimer?: string
  isPublished: boolean
}

/** Full-screen view of the North Star as the client sees it, built from the editor's current state. */
export default function NorthStarPreviewDialog({
  open,
  onClose,
  sections,
  templates,
  clientName,
  currentRole,
  publishedAt,
  disclaimer,
  isPublished,
}: NorthStarPreviewDialogProps) {
  useNorthStarPageStyles(open)

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      aria-label="North Star preview"
      PaperProps={{ sx: { background: '#fbf9f4', color: '#1a1a1a' } }}
    >
      <NorthStarDocument
        sections={sections}
        templates={templates}
        clientName={clientName}
        currentRole={currentRole}
        publishedAt={publishedAt}
        disclaimer={disclaimer}
        previewMode
        banner={
          <Box
            className="ns-no-print"
            role="status"
            sx={{ background: '#fff3cd', color: '#664d03', py: 1, textAlign: 'center', fontSize: 13 }}
          >
            {isPublished
              ? 'PREVIEW · The client sees the last saved version until you Save'
              : 'PREVIEW · Not visible to the client until you Publish'}
          </Box>
        }
      />
      <Button
        className="ns-no-print"
        variant="contained"
        startIcon={<Close />}
        onClick={onClose}
        sx={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          zIndex: (theme) => theme.zIndex.modal + 1,
          background: '#1a1a1a',
          '&:hover': { background: '#333' },
        }}
      >
        Close preview
      </Button>
    </Dialog>
  )
}
